import axios from "axios";
import Vue from "vue";
import { VueAxios } from "./axios";
import { getToken, reLogin } from "./auth.js";
import md5 from "js-md5";
import moment from "moment";
let loadingCount = 0;

// 缓存存储格式：get和post请求数据单独分为两个对象，分别存储url+params的拼接结果作为key值，缓存值作为value
const cache = { get: {}, post: {} };
// 创建一个 axios 实例
// axios.defaults.withCredentials = true;
const service = axios.create({
  baseURL: "/", // 公共的接口地址
  // baseURL: '/FlightService/fsService/rest/', // 公共的接口地址
  timeout: 10000 * 60 * 10, // 请求超时时间设置
  headers: { "X-Custom-Header": "foobar", "Content-Type": "application/json" },
  withCredentials: true,
});

const signkey = "X-Access-Sign";
let signCode = "";

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    if (config.headers.config && config.headers.config.loading) {
      if (loadingCount == 0) {
      }
      loadingCount++;
    }
    // 请求发送之前要做的事情
    const token = sessionStorage.getItem("token");
    config.headers.Token = "Bearer " + token;
    const timestamp = moment(new Date()).startOf("day").valueOf();
    config.headers.sign = md5(
      "gjd2024" + timestamp + "e9338f124737954259d504e335e8b2de"
    );
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 响应拦截器，response为响应的结构组织，包括data，headers，status，statusText，config，request
service.interceptors.response.use(
  (response) => {
    if (
      response.config.headers.config &&
      response.config.headers.config.loading
    ) {
      if (loadingCount > 0) {
        loadingCount--;
        if (loadingCount == 0) {
          // Spin.hide()
        }
      }
    }
    // 后台返回数据
    const data = response.data;
    // 这个状态码和提示信息是和后端约定的
    const { code, msg, resultCode } = data;
    // 根据 code 进行判断，与后端约定某些状态该返回什么数据
    switch (resultCode) {
      // 如果没有 code，可能后端返回的数据不是json类型，直接返回响应结构
      case undefined:
        return response;
      //code === 200 代表没有错误，这里的状态 200 是与后端协商的成功状态码
      case "200":
        return data;
      // 举例：token已过期的code报错，需要返回登录页重新登录！与后端约定20003为token过期状态！
      // 其他 code，抛出错误提示信息
      default:
        return data;
    }
  },
  // 响应拦截的报错信息，协议报错
  (error) => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "请求错误";
          break;
        case 401:
          (error.message = "未授权，请登录"), reLogin();
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = `请求地址错误: ${error.response.config.url}`;
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器内部错误";
          break;
        case 501:
          error.message = "服务未实现";
          break;
        case 502:
          error.message = "网关错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网关超时";
          break;
        case 505:
          error.message = "HTTP版本不受支持";
          break;
        default:
          error.message = "其他未知错误";
          break;
      }
    }
    return Promise.reject(error);
  }
);

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service);
  },
};
Vue.prototype.sendHttp = service;
export { installer as VueAxios, service as axios };



//////////////////
// WEBPACK FOOTER
// ./proxy/request.js
// module id = null
// module chunks = 